'use client';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Box,
  Stack,
  // Avatar,
  AppBar,
  Toolbar,
  Slide
} from '@mui/material';
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FormDialog({
  title,
  subtitle,
  icon,
  open,
  onClose,
  actions,
  children,
  maxWidth = 'sm',
  fullHeight = false,
  showDivider = true,
  fullScreenMode = false,
  subtitleSx = {}
}) {
  if (fullScreenMode) {
    return (
      <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative', backgroundColor: '#ffff' }}>
          <Toolbar>
            <Typography sx={{ flex: 1, color: 'primary.900' }} variant="h4" component="div">
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ p: 3, overflowY: 'auto', height: '100%' }}>
          {subtitle && (
            <Typography variant="body2" color="text.textSecondary" sx={{ mb: 2, ...subtitleSx }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </Box>
        <AppBar sx={{ position: 'relative', backgroundColor: 'transparent' }}>
          <Toolbar sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>{actions && actions}</Box>
          </Toolbar>
        </AppBar>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          overflow: 'hidden'
        }
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box>
            <DialogTitle id="form-dialog-title" sx={{ m: 0, p: 0, fontWeight: 700, fontSize: '1.125rem' }}>
              {title}
            </DialogTitle>
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, ...subtitleSx }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
      </Box>

      {showDivider && <Divider />}

      <DialogContent
        dividers
        sx={{
          px: 4,
          py: 3,
          backgroundColor: 'background.paper',
          maxHeight: fullHeight ? 'calc(100vh - 220px)' : '60vh',
          overflowY: 'auto'
        }}
      >
        {children}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'flex-end', p: 2.5, gap: 1.5 }}>
        {actions ? (
          actions
        ) : (
          <>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                px: 2
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              form=""
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                px: 3,
                fontWeight: 700,
                boxShadow: '0 8px 20px rgba(25,118,210,0.12)'
              }}
            >
              Save
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

FormDialog.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  actions: PropTypes.node,
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  fullHeight: PropTypes.bool,
  showDivider: PropTypes.bool,
  fullScreenMode: PropTypes.bool,
  subtitleSx: PropTypes.object
};

FormDialog.defaultProps = {
  subtitle: '',
  icon: null,
  actions: null,
  children: null,
  maxWidth: 'sm',
  fullHeight: false,
  showDivider: true,
  fullScreenMode: false,
  subtitleSx: {}
};
